<template>
  <v-container>
    <v-card id="repair-details">
<!--      <v-breadcrumbs :items="quote.versions">
         <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :href="item"
      >
        {{ item.toUpperCase() }}
      </v-breadcrumbs-item>
      </template>
      </v-breadcrumbs>
-->
      <v-card-title> Στοιχεία Επισκευής </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          :valid="valid"
        >
        <v-row>
          <v-col cols=2 sm=2 md=2>
          <v-text-field
          label="Αρ. Επισκευής"
          v-model="repair.Id"
          prepend-icon="mdi-counter"
            >
          </v-text-field>
          </v-col>
          <v-col cols=12 sm=4 md=3>
                <v-text-field
                  v-model="repair.Date"
                  label="Ημερομηνία"
                  prepend-icon="mdi-calendar"
                  readonly
                ></v-text-field>
          </v-col>
            <v-col cols=12 sm=4 md=3>
          <v-text-field
            v-model="repair.Vehicle.PlateNumber"
            :prepend-icon="$vehicleBadges[repair.Vehicle.VehType]"
            readonly
            label="Όχημα"
            >
             <template v-slot:append>
              <v-btn icon @click="vehicleDetails"><v-icon>mdi-information</v-icon></v-btn>
            </template>
          </v-text-field>
          </v-col>
          <v-col cols=3 md=3>
          <v-text-field
            v-model="repair.Odometer"
            prepend-icon="mdi-counter"
            label="Ενδ. Ταχογράφου"
            suffix="χιλιόμετρα"
            >
            </v-text-field>

            </v-col>

        </v-row>
         <v-row>
          <v-col cols=12 md=6>
          <v-text-field
            v-model="repair.Vehicle.Owner.Name"
            prepend-icon="mdi-account"
            readonly
            label="Πελάτης"
            >
            <template v-slot:append>
              <v-btn icon @click="accountPage"><v-icon>mdi-information</v-icon></v-btn>
            </template>
            </v-text-field>

            </v-col>
        </v-row>
          <v-row>
          <v-col cols=12 md=6>
          <v-textarea
            v-model="repair.Notes"
            prepend-icon="mdi-notebook"
            rows="1"
            :auto-grow=true
            label="Σημειώσεις"
            hint="Αριθμός πλαισίου, όχημα, κλπ"
            >
         </v-textarea>
          </v-col>
          </v-row>
          <v-row>
          <v-btn
            v-if="repair.InvoiceId"
            v-model="repair.InvoiceId"
            outlined
            dark
            color="primary"
            class="ml-2 white--text"
            :to="{name: 'Invoice', params: {invoid: repair.InvoiceId}}"
            >
            <v-icon>mdi-file-document</v-icon>Τιμολογιο
          </v-btn>
          <v-btn
            outlined
            dark
            color="primary"
            class="ml-2 white--text"
            :to="{name: 'repair-preorders', params: {invoid: repair.Id}}"
            >
            <v-icon>mdi-file-document</v-icon>Παραγγελίες
            </v-btn>
            <v-btn
            v-if="repair.QuoteId"
            v-model="repair.InvoiceId"
            outlined
            dark
             color="primary"
            class="ml-2 white--text"
            :to="{name: 'quote-edit', params: {quoteid: repair.QuoteId}}"
            >
            <v-icon>mdi-file-document-edit</v-icon>Προσφορα
          </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>

      <v-speed-dial
      v-model="fab2"
      right
      bottom
      absolute
      direction="left"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab2"
          color="blue-grey darken-1"
          dark
          fab
        >
          <v-icon v-if="fab2">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-file-pdf-box
          </v-icon>
        </v-btn>
      </template>
             <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getPDF"
              >
              <v-icon dark>mdi-file-pdf-box</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getPDFWOP"
              >
              <v-icon dark>mdi-card-bulleted-outline</v-icon>
            </v-btn>
             <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getPDFBlack"
              >
              <v-icon dark>mdi-card-bulleted</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getPDFCODE39"
              >
              <v-icon dark>mdi-qrcode</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getServiceLabel"
              >
              <v-icon dark>mdi-sticker</v-icon>
            </v-btn>
             <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="send">
              <v-icon dark>mdi-send</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="openGarageDialog">
              <v-icon dark>mdi-folder-image</v-icon>
            </v-btn>
             <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="convertToQuote">
              <v-icon dark>mdi-file-swap</v-icon>
            </v-btn>
        </v-speed-dial>
      <v-speed-dial
      v-model="fab"
      top
      right
      direction="left"
      absolute
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue-grey darken-1"
          dark
          fab
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="updateNotes">
              <v-icon dark>mdi-content-save</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getDCL"
              >
              <v-icon dark>mdi-book</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="dialogHistParts = true"
              >
              <v-icon dark>mdi-history</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="invoice">
              <v-icon dark>mdi-printer-pos</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="digitalClient = true">
              <v-icon dark>mdi-book-open-variant</v-icon>
            </v-btn>
        </v-speed-dial>
      </v-card-actions>
    </v-card>

    <v-card class="mx-auto mt-10" id="item-list" >
      <v-card-title>Λίστα Επισκευών
       <v-btn
            color="blue darken-1"
            icon
            @click="getRepair"
          >
          <v-icon>mdi-refresh</v-icon>
          </v-btn>
      </v-card-title>
      <v-card-text >
    <v-expansion-panels v-if="isAdmin" elevation=0 class="my-2 py-4" accordion>
      <v-expansion-panel>
        <v-expansion-panel-header>Πληροφορίες
        </v-expansion-panel-header>
        <v-expansion-panel-content>

          <v-list>
          <v-subheader>Οικονομικά
          <v-spacer/>
        <v-switch
          v-model="showProfit"
          label="Κέρδος"
          class="mb-4"
        ></v-switch>
          </v-subheader>

      <v-list-group
        :value="false"
        prepend-icon="mdi-wallet-bifold"
      >
        <template v-slot:activator>
          <v-list-item-title>Kέρδος επισκευής</v-list-item-title>
        </template>

        <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-wallet-bifold</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Συνολικό</v-list-item-title>
                  <v-list-item-subtitle>Σ: {{ tocurr(serviceCost+partProfit) }} / {{  ((serviceCost+partProfit)/net*100).toFixed(2) }} %</v-list-item-subtitle>
                  <v-list-item-subtitle>A: {{ tocurr(partProfit) }} / {{  ((partProfit)/net*100).toFixed(2) }} %</v-list-item-subtitle>
                  <v-list-item-subtitle>E: {{ tocurr(serviceCost) }} / {{  ((serviceCost)/net*100).toFixed(2) }} %</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
        <v-list-group
          :value="false"
          no-action
          sub-group
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Κέρδος ανταλλακτικών</v-list-item-title>
            </v-list-item-content>
          </template>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-wallet-bifold</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>κέρδος ανταλλακτικων</v-list-item-title>
                  <v-list-item-subtitle>{{ tocurr(partProfit) }}</v-list-item-subtitle>
                  <v-list-item-subtitle>E: {{ tocurr(partProfit*0.78) }} / Φ: {{ tocurr(partProfit*0.22) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-percent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Προσαύξηση</v-list-item-title>
                  <v-list-item-subtitle>{{ ((partProfit/partCost)*100).toFixed(2) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-percent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Περιθώριο κέρδους</v-list-item-title>
                  <v-list-item-subtitle>{{ (partProfit/(partProfit+partCost)*100).toFixed(2) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-percent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Περιθώριο συνολικού κέρδους</v-list-item-title>
                  <v-list-item-subtitle>{{ (partProfit/(serviceCost+partProfit+partCost)*100).toFixed(2) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-percent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Εισόδημα</v-list-item-title>
                  <v-list-item-subtitle>{{ (0.78 * (partProfit/(partProfit+partCost)*100)).toFixed(2) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-percent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Φόρος εισοδήματος</v-list-item-title>
                  <v-list-item-subtitle>{{ (0.22 * (partProfit/(partProfit+partCost)*100)).toFixed(2) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

        </v-list-group>

        <v-list-group
          :value="false"
          no-action
          sub-group
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Εργασία</v-list-item-title>
            </v-list-item-content>
          </template>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-wallet-bifold</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Εργασία</v-list-item-title>
                  <v-list-item-subtitle>{{ tocurr(serviceCost) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-percent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Περιθώριο κέρδους</v-list-item-title>
                  <v-list-item-subtitle>{{ (serviceCost/(serviceCost+partProfit+partCost)*100).toFixed(2) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

        </v-list-group>
      </v-list-group>
        <v-list-group
          :value="false"
          prepend-icon="mdi-package-variant"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Κόστος Επιχειρισης</v-list-item-title>
            </v-list-item-content>
          </template>

        <v-list-group
          :value="false"
          no-action
          sub-group
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Ανταλλακτικά</v-list-item-title>
            </v-list-item-content>
          </template>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-package</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Ανταλλακτικά</v-list-item-title>
                  <v-list-item-subtitle>{{ tocurr(partCost) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-percent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Ποσοστό</v-list-item-title>
                  <v-list-item-subtitle>{{ (partCost/net*100).toFixed(2) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
          </v-list-group>
        </v-list-group>
    </v-list>
          <v-list max-width="600">
          <v-subheader>Ισοζύγιο κέρδους</v-subheader>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-percent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Ποσοστό</v-list-item-title>
                  <v-list-item-subtitle>{{ (partServiceRatio).toFixed(2) }}</v-list-item-subtitle>
                  <v-slider
                    :max="30"
                    show-ticks="always"
                    step="5"
                    tick-size="4"
                    v-model="partServiceRatio"
                  ></v-slider>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-percent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>ανταλλακτικα</v-list-item-title>
                  <v-list-item-subtitle>{{ tocurr(netParts)}}</v-list-item-subtitle>
                  <v-list-item-subtitle>Αφαίρεση {{ (netParts * partServiceRatio/100).toFixed(2) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-percent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Νέο Ποσό</v-list-item-title>
                  <v-list-item-subtitle>{{ tocurr(netParts - (netParts * partServiceRatio/100)) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-percent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Σχέση ανταλλακτικών - εργασίας</v-list-item-title>
                  <v-list-item-subtitle>{{ ((netParts *(1-partServiceRatio/100)/ net*100)).toFixed(2) }} - {{ ((netService+( netParts * partServiceRatio/100) )/ net*100).toFixed(2) }} </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
          </v-list>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>


      <v-data-table
        :headers="showHeaders"
        :items="repairItemsF"
        item-key="itemId"
        :search="search"
        :item-class="rowClass"
        class="elevation-0"
        height="600px"
        mobile-breakpoint=800
        dense
        show-group-by
        sort-by="Kind"
        fixed-header>

        <v-divider inset></v-divider>
        <template v-slot:top>
          <v-toolbar flat height="120px" color="white">
            <div class="d-flex w-400">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" dense outlined single-line hide-details></v-text-field>
            <v-dialog
                v-model="dialog"
                persistent
                max-width="600px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon dark>mdi-cart-plus</v-icon>
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="repair">
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            label="Κωδικός"
                            :rules="[rules.required]"
                            v-model="editedItem.Sku"
                            dense
                            ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm=8
                          md=8
                          xs=12
                        >
                          <v-text-field
                            label="Περιγραφή*"
                            :rules="[rules.required]"
                            v-model="editedItem.Description"
                            required
                            dense
                            ></v-text-field>
                        </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-text-field
                            label="Ποσότητα*"
                            :rules="[rules.required]"
                            v-model="editedItem.Qty"
                            dense
                            required
                            ></v-text-field>

                      </v-col>
                      <v-col v-if="isAdmin" cols="6" sm="6" md=4>
                          <v-text-field
                            label="Τιμή*"
                            type="number"
                            :rules="[rules.required]"
                            v-model="editedItem.Price"
                            dense
                            required
                            :hint=hintLimit
                            >
                            <template v-slot:append>
                             <!-- <v-btn @click="copySku" icon><v-icon>mdi-content-copy</v-icon></v-btn> -->
                               <v-btn icon v-if="editedItem.Kind==0" @click="showHistory(editedItem)" color="primary">
                                 <v-icon>mdi-history</v-icon>
                               </v-btn>
                             </template>
                            </v-text-field>
                      </v-col>

                      <v-col cols="6" sm="6" md=4>
                    <v-select
                        label="Μονάδα Μέτρησης"
                        v-model="editedItem.Unit"
                        :items="['ΤΕΜ', 'ΣΕΤ', 'ΚΙΛΑ', 'ΛΙΤΡΑ', 'ΜΕΤΡΟ', 'ΩΡΑ','ΚΥΒΙΚΑ', '']"
                        dense
                        single-line>
                      </v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-select
                            label="Κατάσταση"
                            :rules="[rules.required]"
                            v-model="editedItem.Status"
                            :items="statuses"
                            dense single-line
                            required
                            ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-select
                            label="Τεχνικός"
                            :rules="[rules.required]"
                            v-model="editedItem.TechId"
                            :items="technicians"
                            item-text="Name"
                            item-value="Id"
                            dense single-line
                            required
                            ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-select
                            label="Addon"
                            v-model="editedItem.Addon"
                            :items="repairParts"
                            prepend-icon="mdi-tag-plus"
                            item-text="Description"
                            item-value="Id"
                            dense single-line
                            ></v-select>
                      </v-col>
                      </v-row>
                    </v-container>
                    <small>Αγορά: {{ tocurr(editedItem.NetCost) }}<br/></small>
                    <small>Κέρδος: {{ tocurr(editedItem.Price - editedItem.NetCost) }} / {{ tocurr((editedItem.Price - editedItem.NetCost) * 0.78) }} ({{ ((editedItem.Price-editedItem.NetCost)/editedItem.Price*100).toFixed(2) }}% - {{ ((editedItem.Price-editedItem.NetCost)/editedItem.Price*100*0.78).toFixed(2)  }}%)</small><br/>
                    <small>Εφορία: {{ tocurr((editedItem.Price - editedItem.NetCost)*0.22) }} ({{ (((editedItem.Price-editedItem.NetCost)/editedItem.Price*100)* 0.22).toFixed(2) }}%)</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialog = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            <v-btn
                v-if=false
                color="primary"
                class="ml-2 white--text"
                @click="addService"
                >
                <v-icon dark>mdi-account-wrench</v-icon>
            </v-btn>

            <v-dialog
                v-model="dialog2"
                persistent
                max-width="800px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon dark>mdi-account-wrench</v-icon>
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Εισαγωγη Εργασίας</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="service">
                    <v-container>
                      <v-row>

                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Ποσότητα*"
                            :rules="[rules.required]"
                            v-model.number="service.Qty"
                            required
                            persistent-hint
                            ></v-text-field>

                      </v-col>
                       <v-col cols="12" sm="8" md=6>
                        <v-combobox
                          v-model="service"
                          :items="$services"
                          hide-no-data
                          :filter="customServiceFilter"
                          return-object
                          cache-items
                          :hint="`${service.FmSku} - ${service.Description}`"
                          label="Εργασία"
                          @change="onServiceChange"
                        >
                        <template v-slot:selection="data">
                                      {{ data.item.FmSku }} - {{ data.item.Description }}
                                  </template>
                                  <template v-slot:item="{ item }">
                                    <template v-if="typeof item !== 'object'">
                                      <v-list-item-content v-text="item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                      <v-list-item-content>
                                        <v-list-item-title>{{ item.Description }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ item.FmSku }} - {{ tocurr(item.Price) }}</v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>
                                  </template>

                        </v-combobox>

                        </v-col>
                        <v-col>
                        <v-text-field
                          label="Τιμή*"
                          :rules="[rules.required]"
                          v-model="service.Price"
                          type="number"
                          dense
                          required
                          ></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md=4>
                                        <v-select
                                          label="Τεχνικός"
                                          :rules="[rules.required]"
                                          v-model="partTechId"
                                          :items="technicians"
                                          item-text="Name"
                                          item-value="Id"
                                          dense single-line
                                          required
                                          ></v-select>
                                    </v-col>
                                    </v-row>
                                  </v-container>
                                  <small>*indicates required field</small>
                                  </v-form>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="dialog2 = false"
                                  >
                                    Κλείσιμο
                                  </v-btn>
                                  <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="saveService"
                                  >
                                    Αποθήκευση
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>

             <div>
                <!-- activator button -->
                <v-btn color="primary" class="ml-2 white--text" @click="dialog4 = true">
                  <v-icon dark>mdi-wrench-clock</v-icon>
                </v-btn>

                <v-dialog v-model="dialog4" persistent max-width="1000px">
                  <v-card>
                <v-card-title>
                  <span class="text-h5">Εισαγωγη Εργασίας από HaynesPro</span>
                </v-card-title>

               <v-card-text>
                  <v-form ref="service2">
                    <v-container>
                      <v-row>
                        <!-- JSON input shown only when no parsed jobs -->
                        <v-col cols="12" v-if="!jobs.length">
                          <v-textarea
                            v-model="jsonText"
                            label="Paste JSON here"
                            auto-grow
                            rows="4"
                            outlined
                            dense
                            clearable
                            prepend-icon="mdi-code-json"
                          />
                        </v-col>

                        <v-col cols="12" class="d-flex" v-if="!jobs.length">
                          <v-btn color="secondary" @click="parseJson" class="mr-2">Parse JSON</v-btn>
                          <v-btn text @click="reset">Reset</v-btn>
                        </v-col>

                        <!-- Generated menu (editable) - sleek card per job -->
                        <v-col cols="12" v-if="jobs.length">
                            <v-col cols="12" v-for="(job, idx) in jobs" :key="idx">
                              <v-card elevation="2" class="pa-3">
                                <v-card-title class="py-2">
                                  <div class="d-flex align-center" style="width:100%">
                                    <v-icon class="mr-2">mdi-briefcase-clock</v-icon>
                                    <!-- <div class="subtitle-1 font-weight-medium flex-grow-1">{{ job.jobTitle || 'Untitled' }}</div> -->
                                    <v-spacer/>

                                    <v-col cols="6" class="mr-2">
                                      <v-select
                                        label="Τεχνικός"
                                        :rules="[rules.required]"
                                        v-model="job.partTechId"
                                        :items="technicians"
                                        item-text="Name"
                                        item-value="Id"
                                        dense single-line
                                        required
                                        prepend-icon="mdi-account-wrench"
                                        ></v-select>
                                    </v-col>
                                    <v-spacer/>
                                    <v-btn icon small @click="removeJob(idx)" title="Remove job">
                                      <v-icon color="red">mdi-delete</v-icon>
                                    </v-btn>
                                  </div>
                                </v-card-title>

                                <v-card-text class="py-2">
                                  <v-row dense>
                                    <v-col cols="12">
                                      <v-text-field
                                        v-model="job.jobTitle"
                                        label="Job Title"
                                        dense
                                        outlined
                                        prepend-inner-icon="mdi-text"
                                      />
                                    </v-col>

                                    <v-col cols="6" md="4">
                                      <v-text-field
                                        v-model.number="job.time"
                                        label="Time (h)"
                                        type="number"
                                        dense
                                        outlined
                                        prepend-inner-icon="mdi-timer"
                                      />
                                    </v-col>

                                    <v-col cols="6" md="4">
                                      <v-text-field
                                        v-model.number="job.rate"
                                        label="Rate"
                                        type="number"
                                        dense
                                        outlined
                                        prepend-inner-icon="mdi-currency-eur"
                                      />
                                    </v-col>

                                    <v-col cols="12" md="4" class="d-flex align-center">
                                          <v-text-field
                                            :value="computeSubtotal(job)"
                                            label="Sub-total"
                                            dense
                                            outlined
                                            readonly
                                            prepend-inner-icon="mdi-calculator"
                                          />
                                    </v-col>

                                  </v-row>
                                    <v-divider></v-divider>
                                  <v-row>
                                    <v-col cols="12" class="d-flex align-center">
                                      <v-expansion-panels accordion>
                                            <v-expansion-panel>
                                              <v-expansion-panel-header>Sub-jobs</v-expansion-panel-header>
                                              <v-expansion-panel-content>
                                                    <v-col cols="12" v-for="(s, sidx) in job.subJobs" :key="sidx">
                                                      <v-text-field
                                                        v-model="job.subJobs[sidx]"
                                                        label="Sub job"
                                                        dense
                                                        outlined
                                                        prepend-inner-icon="mdi-subdirectory-arrow-right"
                                                        append-outer-icon="mdi-delete"
                                                        @click:append-outer="removeSubJob(idx, sidx)"
                                                      />
                                                    </v-col>

                                                    <v-col cols="12">
                                                      <v-btn small text @click="addSubJob(idx)">
                                                        <v-icon left small>mdi-plus</v-icon> Add sub-job
                                                      </v-btn>
                                                    </v-col>
                                              </v-expansion-panel-content>
                                            </v-expansion-panel>
                                          </v-expansion-panels>
                                    </v-col>
                                </v-row>
                                </v-card-text>
                              </v-card>
                            </v-col>

                          <!-- actions for all jobs -->
                          <v-row class="mt-4">
                            <v-col cols="12" class="d-flex justify-end">
                              <v-btn text class="mr-2" @click="reset">Clear</v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>


                <v-card-actions>
                  <v-spacer/>
                  <v-btn text @click="dialog4 = false">Cancel</v-btn>
                  <v-btn color="primary" :disabled="!jobs.length" @click="saveJobs">Save</v-btn>
                </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>



               <v-dialog
                v-model="dialog3"
                persistent
                max-width="800px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon dark>mdi-package-variant</v-icon>
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Εισαγωγη Ανταλλακτικού</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="invoice">
                    <v-container>
                      <v-row>

                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Ποσότητα*"
                            :rules="[rules.required, rules.qty]"
                            v-model.number="partQty"
                            required
                            :hint="hintQty"
                            persistent-hint
                            ></v-text-field>

                      </v-col>
                       <v-col cols="12" sm="8" md=6>
                       <v-autocomplete
                          v-model="order"
                          :items="partsFiltered"
                          return-object
                          :hint="`${order.SupplierSku} - ${order.FmSku}`"
                          persistent-hint
                          no-filter
                          :search-input.sync="orderSearch"
                          @update:search-input="updateSearchInput"
                          :prepend-icon="prefixIcon"
                          label="Ανταλλακτικό"
                          placeholder="Αναζήτηση με # για SKU, @ για αντιστοιχίες. * για wildcard."
                        >
                          <template v-slot:selection="data">
                              {{ data.item.SupplierSku }} - {{ data.item.ManufacturerSku }} - {{ data.item.Description }}
                          </template>
                          <template v-slot:item="{ item }">
                            <template v-if="typeof item !== 'object'">
                              <v-list-item-content v-text="item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-content>
                                <v-list-item-title>{{ item.ManufacturerSku }} - Παρτίδα {{ item.Id }} ({{ item.Timestamp.slice(0,10) }})</v-list-item-title>
                                <v-list-item-subtitle>Απόθεμα {{ item.StockQty }} {{ item.Unit }} </v-list-item-subtitle>
                                <v-list-item-subtitle>{{ item.FmSku }} (#{{ item.PartId }}) - {{ item.Description }} {{ item.Remarks }} </v-list-item-subtitle>
                                <v-list-item-subtitle>Τιμή: {{ tocurr(item.SuggestedPrice) }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </template>
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>
                                  Δεν βρέθηκαν αποτελέσματα. Δοκιμάστε:
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  <v-btn text @click="prependPrefix('#')"># για SKU</v-btn>
                                  <v-btn text @click="prependPrefix('@')">@ για αντιστοιχίες</v-btn>
                                  <v-btn text @click="prependPrefix('!')">! για Order ID</v-btn>
                                  <v-btn icon @click="clearOrder(0)"><v-icon>mdi-trash-can</v-icon></v-btn>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item v-if="orderSearch">
                              <v-list-item-content>
                                <v-list-item-title>
                                  Αλλαγή τύπου αναζήτησης:
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  <v-btn text @click="prependPrefix('#')"># για SKU</v-btn>
                                  <v-btn text @click="prependPrefix('@')">@ για αντιστοιχίες</v-btn>
                                  <v-btn text @click="prependPrefix('!')">! για Order ID</v-btn>
                                  <v-btn icon @click="clearOrder(1)"><v-icon>mdi-trash-can</v-icon></v-btn>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                        </v-col>
                        <v-col cols="auto">
                          <v-btn @click="getParts()" icon>
                            <v-icon>mdi-refresh</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="6" sm="6" md=4>
                          <v-select
                            label="Τεχνικός"
                            :rules="[rules.required]"
                            v-model="partTechId"
                            :items="technicians"
                            item-text="Name"
                            item-value="Id"
                            dense single-line
                            required
                            ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="4">
                        <v-switch
                          v-model="isCollection"
                          label="Επισκευή/Συλλογή"
                          :true-value="-1"
                          :false-value="1"
                        ></v-switch>
                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialog3 = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="savePart"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
                <v-dialog
                  v-model="barcodeDialog"
                  persistent
                  max-width="900px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text"
                      @click:open="focusBarcodeInput"
                    >
                      <v-icon dark>mdi-qrcode-scan</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">Barcode Scanner</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="barcodeForm">
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-text-field
                                label="Barcode"
                                :rules="[rules.required]"
                                :error="barcodeError"
                                :error-messages="barcodeErrorMessage"
                                required
                                clearable
                                @keyup.enter="checkBarcode"
                                ref="barcodeInputField"
                              ></v-text-field>
                            </v-col>

                            <!-- Tabs for Checkout and Collection -->
                            <v-col cols="12" sm="12" md="12">
                              <v-tabs v-model="activeTab">
                                <v-tab>Χρεωση</v-tab>
                                <v-tab>Συλλογη</v-tab>
                              </v-tabs>

                              <v-tabs-items v-model="activeTab">
                                <v-tab-item>
                                  <!-- Checkout Tab Content -->
                                  <v-data-table
                                    :headers="headersBarcode"
                                    :items="scannedItems"
                                    class="elevation-1"
                                    item-key="uniqueId"
                                    height="400px"
                                    :item-class= "barcodeRowClasses"
                                  >
                                    <template v-slot:no-data>
                                      Εδώ θα εμφανιστούν τα ανταλλακτικά συμπληρωμένα με το κωδικό που αναζητήσατε μέσω barcode.
                                    </template>
                                    <template v-slot:item.CoQty="{ item }">
                                      <v-text-field
                                        v-model.number="item.CoQty"
                                        type="number"
                                        min="1"
                                        :max="item.StockQty"
                                        dense
                                        hide-details
                                        @input="validateCoQty(item)"
                                      ></v-text-field>
                                    </template>
                                    <template v-slot:item.SuggestedPrice="{ item }">
                                      {{ tocurr(item.SuggestedPrice) }}
                                    </template>
                                    <template v-slot:item.Timestamp="{ item }">
                                      {{ item.Timestamp.slice(0,10) }}
                                    </template>
                                    <template v-slot:item.actions="{ item }">
                                      <v-btn icon @click="deleteBarcodeItem(item)">
                                        <v-icon>mdi-delete</v-icon>
                                      </v-btn>
                                    </template>
                                  </v-data-table>
                                </v-tab-item>

                                <v-tab-item>
                                  <!-- Collection Tab Content -->
                                  <v-data-table
                                    :headers="headersCollection"
                                    :items="collectionItems"
                                    class="elevation-1"
                                    item-key="uniqueId"
                                    height="400px"
                                  >
                                    <template v-slot:no-data>
                                      <v-btn
                                        color="primary"
                                        :disabled="scannedItems.length===0"
                                        @click="copyCheckoutToCollection"
                                      >
                                        Αντιγραφη γραμμων απο καρτελα χρεωσης
                                      </v-btn>
                                    </template>
                                  </v-data-table>
                                </v-tab-item>
                              </v-tabs-items>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                              <v-select
                                label="Τεχνικός"
                                :rules="[rules.required]"
                                v-model="partTechId"
                                :items="technicians"
                                item-text="Name"
                                item-value="Id"
                                dense single-line
                                required
                              ></v-select>
                            </v-col>
                          </v-row>
                        </v-container>
                        <small>*indicates required field</small>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="red"
                        text
                        :disabled="scannedItems.length===0"
                        @click="clearAllItems"
                      >
                        Clear All
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="barcodeDialog = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        :disabled="scannedItems.length===0"
                        @click="copyCheckoutToCollection"
                      >
                        Collect
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        :disabled="scannedItems.length===0"
                        @click="saveBarcodeData"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>


              <v-spacer/>
               <v-col
                  class="py-0"
                >
                  <v-btn-toggle
                    v-model="showServicesOnly"
                    background-color="white"
                    color="blue lighten-2"
                    multiple
                    mandatory
                  >
                    <v-btn>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" >
                            <v-icon v-if="showServicesOnly.includes(0)">mdi-package-variant</v-icon>
                            <v-icon v-else>mdi-package-variant-closed</v-icon>
                          </span>
                        </template>
                        <span>Ανταλλακτικά: {{ tocurr(netItems) }}</span>
                      </v-tooltip>
                      </v-btn>
                    <v-btn>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" >
                            <v-icon v-if="showServicesOnly.includes(1)">mdi-account-wrench</v-icon>
                            <v-icon v-else>mdi-account</v-icon>
                          </span>
                        </template>
                        <span>Εργασία: {{ tocurr(netService) }}</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" >
                            <v-icon v-if="showServicesOnly.includes(2)">mdi-package-variant-plus</v-icon>
                            <v-icon v-else>mdi-package-variant-closed-plus</v-icon>
                          </span>
                        </template>
                        <span>Έξτρα: {{ tocurr(netAddons) }}</span>
                      </v-tooltip>
                    </v-btn>

                  </v-btn-toggle>
                </v-col>
        <div v-if="isAdmin" class="text-right pa-10 ma-0">
          <p><b>Σύνολο:</b>&nbsp;
          <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >{{ tocurr(netServiceRatio) }}</span>
      </template>
      <span>Ανταλλακτικά: {{ tocurr(netParts *(partServiceEnabled ? (1 - partServiceRatio / 100) : 1)) }}, Εργασία: {{ tocurr(netService + partDiscount) }} </span>
    </v-tooltip></p>
          <p><b>ΦΠΑ 24%:</b>&nbsp; {{ tocurr(vat) }}</p>
          <p><b>Γενικό Σύνολο:</b>&nbsp; {{ tocurr(total) }}</p>
        </div>
            </v-toolbar>
          </template>

        <template v-slot:item.index="{ item }">
          <span>{{repairItems.indexOf(item)+1}}</span>
        </template>
        <template v-slot:item.Status="{ item }">
          <span>{{ getStatus(item.Status) }}</span>
        </template>

        <template v-slot:item.TechId="{ item }">
          <span>{{ technicians[item.TechId-1].Name }}</span>
        </template>
         <template v-slot:item.Sku="{ item }">
          <span v-if="item.CheckoutPart">
            <v-btn icon :to="{name: 'order-info', params: {id: item.CheckoutPart}}">
            <v-icon plain color="teal darken-2" v-if="item.Kind==2" >mdi-tag-plus</v-icon>
            <v-icon plain color="teal darken-2" v-else >mdi-package-variant-closed</v-icon>
            </v-btn>
            </span>
            <span v-if="!item.CheckoutPart">
            <v-icon class="mx-2 px-0" v-if="item.Kind==1">mdi-account-wrench</v-icon>
            <v-icon class="mx-2 px-0" v-else-if="item.Kind==2">mdi-tag-plus</v-icon>
            <v-icon class="mx-2 px-0" v-else>mdi-package-variant-closed</v-icon>
            </span>
            <span>{{ item.Sku }}</span>
        </template>
        <template v-slot:item.Price="{ item }">
          <div v-if="item.Kind!=1">
            <span v-if="isNaN(item.Price)">{{ tocurr(0) }}</span>
            <span v-else>
              <span v-if="repairAddons.filter(e=>e.Addon == item.Id).length">{{ tocurr((parseFloat(addonsValue(item)/item.Qty) + parseFloat(item.Price * (partServiceEnabled ? (1 - partServiceRatio / 100) : 1)) )) }}</span>
              <span v-else>{{ tocurr(item.Price * (partServiceEnabled ? (1 - partServiceRatio / 100) : 1))}}</span>
              </span>
            </div>
          <div v-else>
            <span v-if="isNaN(item.Price)">{{ tocurr(0) }}</span>
            <span v-else-if="partServiceEnabled">{{ tocurr(roundToNearestTenOrFive(item.Price + (partDiscount * item.Price / netService))) }}</span>
            <span v-else>{{ tocurr(item.Price) }}</span>
          </div>
        </template>
        <template v-slot:item.vat="{ item }">
          <span v-if="isNaN(item.Price)"></span>
            <span v-if="repairAddons.filter(e=>e.Addon == item.Id).length">{{ tocurr((addonsValue(item) + item.Qty*item.Price)*0.24)}}</span>
            <!-- <span v-else-if="item.Kind==1">{{ tocurr(item.Qty*(item.Price + (partServiceEnabled ? (partDiscount * item.Price / netService ) : 0)) *0.24)}}</span>
            <span v-else>{{ tocurr(item.Qty*item.Price*(partServiceEnabled ? (1 - partServiceRatio / 100) : 1) *0.24)}}</span> -->
            <span v-else-if="partServiceEnabled">{{ tocurr(roundToNearestTenOrFive(item.Price + (partDiscount * item.Price / netService))) *0.24}}</span>
            <span v-else>{{ tocurr(item.Qty* item.Price * 0.24) }}</span>
        </template>
        <template v-slot:item.gross="{ item }">
          <span v-if="isNaN(item.Price)"></span>
            <span v-if="repairAddons.filter(e=>e.Addon == item.Id).length">{{ tocurr((addonsValue(item) + item.Qty*item.Price))}}</span>
            <!-- <span v-else-if="item.Kind==1">{{ tocurr(item.Qty*(item.Price +(partServiceEnabled ? (partDiscount * item.Price / netService ) : 0)))}}</span>
            <span v-else>{{ tocurr(item.Qty*item.Price* (partServiceEnabled ? (1 - partServiceRatio / 100) : 1))}}</span> -->
            <span v-else-if="partServiceEnabled==true">{{ tocurr(roundToNearestTenOrFive(item.Price + (partDiscount * item.Price / netService)))}}</span>
            <span v-else>{{ tocurr(item.Qty* item.Price) }}</span>
        </template>
        <template v-slot:item.value="{ item }">
          <span v-if="isNaN(item.Price)"></span>
            <span v-else-if="repairAddons.filter(e=>e.Addon == item.Id).length">{{ tocurr((addonsValue(item) + item.Qty*item.Price)*1.24)}}</span>
            <span v-else-if="item.Kind==1">{{ tocurr(item.Qty*(item.Price +(partServiceEnabled ? (partDiscount * item.Price / netService ) : 0) ) * 1.24 )}}</span>
            <span v-else>{{ tocurr(item.Qty*item.Price *(partServiceEnabled ? (1 - partServiceRatio / 100) : 1) *1.24)}}</span>
        </template>

        <template v-if="showProfit" v-slot:item.profit="{ item }">
          <span v-if="item.Kind==1">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" >
              {{ tocurr(item.Qty * item.Price) }} </span>
          </template>
         Margin: 100%
          </v-tooltip>
        </span>
          <span v-else>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" >
              {{ tocurr(item.Qty * item.Profit) }} </span>
          </template>
          {{  `Margin: ${(item.Profit/item.Price * 100).toFixed(2)}%`}}
        </v-tooltip>

      </span>
        </template>

        <template v-slot:item.actions="{ item }">
          <div>
            <v-icon class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <!-- <v-icon class="mr-3" @click="copyItem(item)">
              mdi-content-copy
            </v-icon> -->
            <v-icon v-if="item.Kind==0" class="mr-3" @click="locateItem(item)">
              mdi-crosshairs
            </v-icon>
            <v-icon @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </div>
        </template>

        <template
        v-slot:group.header="{ group, groupBy, items, isOpen, toggle, remove }"
      >
        <th colspan="10">
          <v-icon @click="toggle"
            >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
          </v-icon>
         <v-span  v-if="groupBy=='Sku'" round color="primary">Κωδικός: {{ group }} </v-span>
         <v-chip  v-else color="primary">{{ group }}</v-chip>
          <v-chip round color="light-blue darken-4" text-color="white">Ποσότητα: {{ $sumField(items, "Qty") }}</v-chip>
          <v-chip round color="light-blue darken-4" text-color="white">Κοστος: {{ $tocurr(sumTotals(items)) }}</v-chip>
          <v-icon @click="remove">mdi-close </v-icon>
        </th>
   </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      </v-card-text>
      <v-card-actions >
      </v-card-actions>
    </v-card>
   <v-snackbar
   timeout=2500
   v-model="snackbar">
      {{ snackText }}
  </v-snackbar>

   <v-dialog
      v-model="dialogHist"
      width="auto"
    >
      <v-card>
       <v-card-title> Προηγούμενες χρεώσεις </v-card-title>
        <v-card-text>
        <v-container>
           <v-data-table
        :headers="chargesHeader"
        :loading="loading"
        :items="charges"
        :item-class="rowClass"
        class="elevation-0"
        height="400px"
        mobile-breakpoint=800
        :items-per-page=5
        fixed-header>
         <template v-slot:item.Timestamp="{ item }">
       {{  new Date(item.Timestamp).toLocaleDateString()  }}
    </template>

    <template v-slot:item.actions="{ item }">
             <v-btn
              class="mr-2"
              icon
              small
            :to="{name: 'edit-repair', params: {repairId: item.RepairId}, target: '_blank'}"
            >
              <v-icon>mdi-car-wrench</v-icon>
            </v-btn>
                </template>
        </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="dialogHist = false">Κλεισιμο</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogHistParts"
      width="auto"
    >
      <v-card>
       <v-card-title> Προηγούμενες χρεώσεις Ανταλλακτικών </v-card-title>
        <v-card-text>
        <v-container>
         <v-text-field v-model="historySearch"
          append-icon="mdi-magnify"
          label="Search"
          dense
          outlined
          single-line
          hide-details
          ></v-text-field>
        <v-data-table
        :headers="histPartsHeader"
        :loading="loading"
        :items="histParts"
        :item-class="rowClass"
        :search="historySearch"
        class="elevation-0"
        height="400px"
        mobile-breakpoint=800
        :items-per-page=5
        fixed-header>
         <template v-slot:item.Timestamp="{ item }">
       {{  new Date(item.Timestamp).toLocaleDateString()  }}
    </template>

    <template v-slot:item.actions="{ item }">
             <v-btn
              class="mr-2"
              icon
              small
            :to="{name: 'edit-repair', params: {repairId: item.RepairId}, target: '_blank'}"
            >
              <v-icon>mdi-car-wrench</v-icon>
            </v-btn>
            <v-btn
              v-if="item.PartId"
              class="mr-2"
              icon
              small
            :to="{name: 'part-orders', params: {id: item.PartId}, target: '_blank'}"
            >
              <v-icon>mdi-package-variant-closed</v-icon>
            </v-btn>
                </template>
        </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="dialogHistParts = false">Κλεισιμο</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <PrintServiceLabel
      :item="repairId"
      :showDialog="labelShow"
      @close="handleDialogClose"
    />

    <v-dialog
      v-model="digitalClient"
      max-width="600px"
    >
    <v-card>
      <v-card-title>
        <span v-if="!repair.DigitalClientListId">Δημιουργία εγγραφής ψηφιακού πελατολογίου</span>
        <span v-else-if="!digitalClientCompleted">Ενημέρωση εγγραφής</span>
        <span v-else>Συσχέτιση Τιμολογίου</span>
      </v-card-title>
      <v-card-text>
        <div v-if="!repair.DigitalClientListId">
          <v-textarea
              v-model="digitalClientComments"
              label="Σχόλια"
              placeholder="Προσθέστε σχόλια για την εγγραφή"
              outlined
              dense
              class="mb-4"
            ></v-textarea>
          <v-btn color="primary" @click="createDigitalClientEntry" :loading="creatingDigitalClient" :disabled="creatingDigitalClient">
            Δημιουργία
          </v-btn>
        </div>
        <div v-else-if="!digitalClientCompleted">
          <v-select
            v-model="digitalClientForm.serviceType"
            :items="serviceTypes"
            item-text="text"
            item-value="value"
            label="Κατηγορία Παρεχόμενης Υπηρεσίας"
            outlined
            dense
          ></v-select>
          <v-checkbox
            v-model="digitalClientForm.completed"
            label="Ολοκλήρωση Εγγραφής"
          ></v-checkbox>
          <v-textarea
              v-model="digitalClientForm.comments"
              label="Σχόλια"
              placeholder="Ενημερώστε τα σχόλια για την εγγραφή"
              outlined
              dense
              class="mb-4"
            ></v-textarea>
          <v-btn color="primary" @click="updateDigitalClientEntry" :loading="updatingDigitalClient" :disabled="updatingDigitalClient">
            Update Entry
          </v-btn>
          <v-divider class="my-4"></v-divider>
          <div>
            <h3 class="subtitle-1 mb-2">Update History</h3>
            <v-list dense>
              <v-list-item v-for="update in digitalClientUpdates" :key="update.Id">
                <v-list-item-content>
                  <v-list-item-title>{{ update.Id }} {{ update.Completed ? 'Ολοκλήρωση': 'Εκκρεμής' }}</v-list-item-title>
                  <v-list-item-subtitle>{{ update.CompletionDateTime }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ update.ProvidedServiceCategory.Desc }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ update.InvoiceKind.Desc }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="digitalClientUpdates.length === 0">
                <v-list-item-content>
                  <v-list-item-title>No updates yet.</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </div>
        <div v-else>
          <!-- <div>
            <h3 class="subtitle-1 mb-2">Βρέθηκαν μη συσχετισμένα τιμολόγια</h3>
              <v-list>
                <v-list-item-group>
                  <v-list-item v-for="invoice in digitalClientCorrelatedInvos" :key="invoice.Id">
                    <v-card
                      class="mx-2 my-1"
                      width="90%"
                      elevation="2"
                      :class="{
                        'selected-invoice': isInvoiceSelected(invoice),
                        'correlated-invoice': isInvoiceCorrelated(invoice)
                      }"
                      @click="toggleInvoiceSelection(invoice)"
                      :style="isInvoiceCorrelated(invoice) ? 'cursor: not-allowed; opacity: 0.7;' : 'cursor: pointer;'"
                    >
                      <v-card-title>
                        <v-row align="center" justify="space-between">
                          <v-col>
                            <div class="d-flex align-center">
                              <v-icon class="mr-2">{{ getIcon(invoice.TypeCode) }}</v-icon>
                              <span class="font-weight-bold">{{ invoice.InvoiceDoc }}</span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <v-card-subtitle>
                        <v-row justify="space-between">
                          <v-col>
                            <div>Αξία: {{ $tocurr(invoice.NetValue) }}</div>
                            <div>ΦΠΑ: {{ $tocurr(invoice.VatValue) }}</div>
                          </v-col>
                          <v-col class="text-right">
                            <div class="font-weight-bold">Σύνολο: {{ $tocurr(invoice.TotalValue) }}</div>
                            <div>{{ invoice.Date }}</div>
                          </v-col>
                        </v-row>
                      </v-card-subtitle>
                    </v-card>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
          </div>

          <v-btn
            color="primary"
            @click="correlateInvoices"
            :loading="correlatingDigitalClient"
            :disabled="correlatingDigitalClient || selectedInvoices.length === 0"
          >
            Συσχέτιση τιμολογίου
          </v-btn>
          <v-divider class="my-4"></v-divider>
          <div> -->

            <div>

              <!-- Empty state -->
              <div v-if="digitalClientCorrelatedInvos.length === 0" class="text--secondary mb-4">
                Δεν βρέθηκαν τιμολόγια σε συσχέτιση
              </div>

              <!-- Existing correlated invoices -->
              <template v-else>
                <v-list>
                  <v-list-item-group>
                    <v-list-item
                      v-for="invoice in digitalClientCorrelatedInvos"
                      :key="invoice.Id"
                    >
                      <v-card
                        class="mx-2 my-1"
                        width="90%"
                        elevation="2"
                        :class="{
                          'selected-invoice': isInvoiceSelected(invoice),
                          'correlated-invoice': isInvoiceCorrelated(invoice)
                        }"
                        @click="!isInvoiceCorrelated(invoice) && toggleInvoiceSelection(invoice)"
                        :style="isInvoiceCorrelated(invoice) ? 'cursor: not-allowed; opacity: 0.7;' : 'cursor: pointer;'"
                      >
                        <v-card-title>
                          <v-row align="center" justify="space-between">
                            <v-col>
                              <div class="d-flex align-center">
                                <v-icon class="mr-2">{{ getAadeIcon(invoice.InvoiceType.Type) }}</v-icon>
                                <span class="font-weight-bold">{{ invoice.InvoiceDoc }}</span>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-title>
                        <v-card-subtitle>
                          <v-row justify="space-between">
                            <v-col>
                              <div>Αξία: {{ $tocurr(invoice.NetValue) }}</div>
                              <div>ΦΠΑ: {{ $tocurr(invoice.VatValue) }}</div>
                            </v-col>
                            <v-col class="text-right">
                              <div class="font-weight-bold">Σύνολο: {{ $tocurr(invoice.TotalValue) }}</div>
                              <div>{{ invoice.Date }}</div>
                            </v-col>
                          </v-row>
                        </v-card-subtitle>
                        <v-card-actions v-if="isInvoiceCorrelated(invoice)">
                          <v-chip color="success" small>Ήδη συσχετισμένο</v-chip>
                        </v-card-actions>
                      </v-card>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>

                <!-- If all are correlated, show find new invoices button -->
                <div v-if="allCorrelated">
                  <div class="my-2 text--secondary">Όλα τα τιμολόγια έχουν ήδη συσχετιστεί.</div>
                  <v-btn
                    color="primary"
                    @click="findCorrelations"
                    :loading="findingCorrelations"
                    :disabled="findingCorrelations"
                  >
                    Εύρεση νέων τιμολογίων
                  </v-btn>
                </div>
                <!-- If not all correlated, show correlate button -->
                <div v-else>
                  <v-btn
                    color="primary"
                    @click="correlateInvoices"
                    :loading="correlatingDigitalClient"
                    :disabled="correlatingDigitalClient || selectedInvoices.length === 0"
                  >
                    Συσχέτιση τιμολογίου
                  </v-btn>
                </div>
              </template>

              <!-- Divider and new found invoices -->
              <template v-if="digitalClientNewCorrelationInvos && digitalClientNewCorrelationInvos.length > 0">
                  <v-divider class="my-4"></v-divider>
                <h4 class="subtitle-2 mb-2">Νέα τιμολόγια προς συσχέτιση</h4>
                <v-list>
                  <v-list-item-group>
                    <v-list-item
                      v-for="invoice in digitalClientNewCorrelationInvos"
                      :key="invoice.Id"
                    >
                      <v-card
                        class="mx-2 my-1"
                        width="90%"
                        elevation="2"
                        :class="{
                          'selected-invoice': isInvoiceSelected(invoice)
                        }"
                        @click="toggleInvoiceSelection(invoice)"
                        style="cursor: pointer;"
                      >
                        <v-card-title>
                          <v-row align="center" justify="space-between">
                            <v-col>
                              <div class="d-flex align-center">
                                <v-icon class="mr-2">{{ getIcon(invoice.TypeCode) }}</v-icon>
                                <span class="font-weight-bold">{{ invoice.InvoiceDoc }}</span>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-title>
                        <v-card-subtitle>
                          <v-row justify="space-between">
                            <v-col>
                              <div>Αξία: {{ $tocurr(invoice.NetValue) }}</div>
                              <div>ΦΠΑ: {{ $tocurr(invoice.VatValue) }}</div>
                            </v-col>
                            <v-col class="text-right">
                              <div class="font-weight-bold">Σύνολο: {{ $tocurr(invoice.TotalValue) }}</div>
                              <div>{{ invoice.Date }}</div>
                            </v-col>
                          </v-row>
                        </v-card-subtitle>
                      </v-card>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-btn
                  color="primary"
                  @click="correlateInvoices"
                  :loading="correlatingDigitalClient"
                  :disabled="correlatingDigitalClient || selectedInvoices.length === 0"
                >
                  Συσχέτιση νέων τιμολογίων
                </v-btn>
              </template>
            </div>

            <h3 class="subtitle-1 mb-2">Update History</h3>
            <v-list dense>
              <v-list-item v-for="update in digitalClientUpdates" :key="update.Id">
                <v-list-item-content>
                  <v-list-item-title>{{ update.Id }} {{ update.Completed ? 'Ολοκλήρωση': 'Εκκρεμής' }}</v-list-item-title>
                  <v-list-item-subtitle>{{ update.CompletionDateTime }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ update.ProvidedServiceCategory.Desc }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ update.InvoiceKind.Desc }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="digitalClientUpdates.length === 0">
                <v-list-item-content>
                  <v-list-item-title>No updates yet.</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="digitalClient = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="locationDialog" max-width="450px">
  <v-card>
    <v-img
      :src="axleConfigImage"
      aspect-ratio="3"
      class="mb-2"
      height="120"
      contain
      style="background-color: #fff;"

    />
    <v-card-title>Επεξεργασία Θέσης</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-select
            v-model="locationFields.cabAxle"
            :items="cabAxleItems"
            label="Cab/Άξονας"
            outlined
            dense
            required
          ></v-select>
          <v-checkbox
            v-model="axleChecked"
            :disabled="locationFields.cabAxle === 'CAB'"
            label="Άξονας"
            class="ml-4"
            hide-details
            style="margin-top: 0;"
          ></v-checkbox>
        </v-col>
        <v-col v-if="!axleChecked" cols="12">
          <v-btn-toggle
            v-model="locationFields.side"
            mandatory
            class="ma-2"
          >
            <v-btn value="L">
              <v-icon left>mdi-arrow-left-circle</v-icon>
              Αριστερα
            </v-btn>
            <v-btn value="M">
              <v-icon left>mdi-plus-circle</v-icon>
              Μεση
            </v-btn>
            <v-btn value="R">
              <v-icon left>mdi-arrow-right-circle</v-icon>
              Δεξια
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="locationFields.front"
            label="Μπροστά (Front)"
            :disabled="locationFields.back"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="locationFields.back"
            label="Πίσω (Back)"
            :disabled="locationFields.front"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn text @click="locationDialog = false">Ακύρωση</v-btn>
      <v-btn color="primary" text @click="saveLocationDialog">Αποθήκευση</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<repair-garage-dialog v-model="garageDialog" @uploaded="onGarageUploaded" />
  </v-container>
</template>

<script>
//const _ = require("lodash");
import PrintServiceLabel from '../../components/PrintServiceLabel.vue';
import RepairGarageDialog from '../../components/RepairGarageDialog.vue';

// import filter from "lodash/filter";

export default {
  components: {
    PrintServiceLabel,
    RepairGarageDialog
  },
  watch: {
    partServiceRatio(newVal) {
      // Run your function here when partServiceRatio is updated
      this.partServiceRatioUpdate(newVal);
    },
    orderSearch(val) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.fetchPartsFilter(val);
      }, 250); // Adjust the delay as needed
    },
    'locationFields.cabAxle'(val) {
      if (val === 'CAB') {
        this.axleChecked = false;
      }
    },
    digitalClient(newVal) { if (newVal && !this.digitalClientInitialized) { this.digitalClientInitialized = true; this.fetchDigitalClientDetails(); } },
    axleChecked(val) {
      if (val) {
        this.locationFields.side = 'A';
      } else if (this.locationFields.side === 'A') {
        this.locationFields.side = '';
      }
    },
  },
  computed: {
    hintQty () {
      return `Διαθέσιμα: ${this.order.StockQty}`
    },
    hintLimit () {
      return `Τιμή > ${this.editedItem.Limit}`
    },
    collectionItems() {
      return this.repairItems.filter(e=>e.Status == -1 && e.CheckoutPart)
    },
    net () {
      return this.sumTotals(this.repairItems.filter(e=>e.Status !=-1));
    },
    netServiceRatio () {
      return (this.netParts * (this.partServiceEnabled ? (1 - this.partServiceRatio / 100) : 1)) + (this.netService + this.partDiscount)
    },
    netItems () {
      return this.sumTotals(this.repairItems.filter(e=>e.Status !=-1).filter(e=>e.Kind==0));
    },
    netParts () {
      return this.sumTotals(this.repairItems.filter(e=>e.Status !=-1).filter(e=>e.Kind!=1));
    },
    netService () {
      return this.sumTotals(this.repairItems.filter(e=>e.Status !=-1).filter(e=>e.Kind==1));
    },
    netAddons () {
      return this.sumTotals(this.repairItems.filter(e=>e.Status !=-1).filter(e=>e.Kind==2));
    },
    vat () {
      return Number(this.net) * 0.24;
    },
    total () {
      return Number(this.net) + Number(this.vat);
    },
    partProfit () {
      return this.sumProfit(this.repairItems.filter(e=>e.Status !=-1 & e.Kind != 1));
    },
    partCost () {
      return this.sumCost(this.repairItems.filter(e=>e.Status !=-1 & e.Kind != 1));
    },
    serviceCost () {
      return this.sumService(this.repairItems.filter(e=>e.Kind == 1));
    },
    invoicedProfit () {
          return this.sumProfit(this.repairItems.filter(e=>e.Status == 0 & e.Kind != 1));
    },
    profit () {
      return this.sumProfit(this.repairItems.filter(e=>e.Status !=-1));
    },
    pdfPath () {
        return `${this.$api.defaults.baseURL}/repairs/${this.repair.Id}/card/`;
    },
    showHeaders() {
         const profitColumn = {
        text: 'Κέρδος',
        value: 'profit',
        sortable: false,
        groupable: false,
      };
      let headers = [];
      let baseheaders = [];
      const headersToExclude = ["vat", "Status", "value", "TechId"];

      if (!this.isAdmin) {
        headers.push("Price", "gross", "value", "vat");
      }
      if (this.$vuetify.breakpoint.smAndDown) {

        headers.push(headersToExclude)
        baseheaders = this.headers.filter(h => !headers.includes(h.value));
      } else {
        baseheaders = this.headers.filter(h => !headers.includes(h.value));
      }
        return this.showProfit
      ? [...baseheaders, profitColumn]
      : baseheaders;
    },
    repairItemsF() {
        if (this.showServicesOnly) {
            return this.repairItems.filter(e => this.showServicesOnly.includes(e.Kind) );
        } else {
            return this.repairItems;
        }
    },
    repairParts() {
      return this.repairItems.filter(e => e.Kind == 0 );
    },
    repairAddons() {
      return this.repairItems.filter(e => e.Kind == 2 );
    },
    formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    isAdmin() {
        if (!this.$store.state.authentication.user) return false;
        return this.$store.state.authentication.user.scopes.includes("income");
    },
    allCorrelated() {
      // Returns true if all invoices in digitalClientCorrelatedInvos are correlated
      return (
        this.digitalClientCorrelatedInvos.length > 0 &&
        this.digitalClientCorrelatedInvos.every(inv => this.isInvoiceCorrelated(inv))
      );
    },
    axleConfigImage() {
    // Example: Vehicle.AxleConfig = '4x2'
    // Adjust the path as needed for your project structure
    return require(`@/assets/axle_configs/axle_conf_${this.repair.Vehicle.AxleConf}.jpg`);
    },
    cabAxleItems() {
      // Assume vehicle.AxleConf is available in your component
      const conf = this.repair.Vehicle?.AxleConf;
      let axles = 2;
      if (conf === null || conf === undefined || conf === 0 || conf === 1) {
        axles = 2;
      } else if (conf >= 2 && conf <= 6) {
        axles = 3;
      } else if (conf >= 7 && conf <= 12) {
        axles = 4;
      } else if (conf === 13) {
        axles = 3;
        // Only axles, no 'CAB'
        return Array.from({ length: axles }, (_, i) => (i + 1).toString());
      } else if (conf === 14) {
        axles = 2;
        // Only axles, no 'CAB'
        return Array.from({ length: axles }, (_, i) => (i + 1).toString());
      }
      // Always include 'CAB' as the first option
      return ['CAB', ...Array.from({ length: axles }, (_, i) => (i + 1).toString())];
    }
  },

  data () {
    return {
    menu: false,
    showProfit: false,
    fab: false,
    fab2: false,
    garageDialog: false,
    snackbar: false,
    snackText: "",
    valid: true,
    dialog: false,
    dialog2: false,
    dialog3: false,
    dialog4: false,
    dialogHist: false,
    dialogHistParts: false,
    loading: false,
    selectedItem: null,
    showServicesOnly: [0,1],
    repair: {},
    isCollection: 1,
    partServiceRatio: 0,
    partServiceEnabled: false,
    partDiscount: 0,
    labelShow: false,
    repairId: null,
    debounceTimeout: null,
    service: {
          FmSku: "030",
          Description: "ΕΞΑΓΩΓΗ ΚΑΙ ΑΝΤΙΚΑΤΑΣΤΑΣΗ ΑΝΤΑΛΛΑΚΤΙΚΩΝ",
          Price: 0,
          Qty: 1,
        },

    technicians: {},
    order: {StockQty:0},
    partQty: 1,
    partTechId: 1,
    parts: [],
    partsFiltered: [],
    histParts: [],
    charges: [],
    rules: {
        required: value => !!value || 'Required.',
        qty: value => value <= this.order.StockQty || 'Out of stock!',
        limit: value => value <= this.editedItem.Limit || 'Τιμή κάτω του κόστους'

    },
    jsonText: `[]`,
    jobs: [],
    digitalClient: false,
    digitalClientInitialized: false,
    creatingDigitalClient: false,
    updatingDigitalClient: false,
    correlatingDigitalClient: false,
    digitalClientComments: null,
    digitalClientForm: {
      serviceType: null,
      completed: false,
      comments: null,
    },
    digitalClientCompleted: false,
    digitalClientCorrelatedInvos: [],
    digitalClientNewCorrelationInvos: [],
    correlatedInvos: [],
    digitalClientCorrelations: [],
    digitalClientUpdates: [],
    selectedInvoices: [],
    serviceTypes: [
      { value: 1, text: 'Εργασία με χρήση ανταλλακτικών' },
      { value: 2, text: 'Εργασία με χρήση ανταλλακτικών που προσκομίζονται από τον πελάτη' },
      { value: 3, text: 'Εργασία χωρίς χρήση ανταλλακτικών' },
      { value: 4, text: 'Δωρεάν υπηρεσία' },
      { value: 6, text: 'Αποζημίωση παροχής εγγύησης' },
      { value: 9, text: 'Ιδιόχρηση' }
    ],
    search: '',
    orderSearch: '',
    prefixIcon: 'mdi-tag',
    historySearch: '',
    headers: [
      {
        text: 'A/A',
        value: 'index',
        sortable: false,
        width: '5%',
        groupable: false,
      },
      {
        text: 'Κωδικός',
        value: 'Sku',
        sortable: true,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        sortable: false,
        groupable: false,
        width: '25%'
      },
      {
        text: 'Ποσότητα',
        value: 'Qty',
        sortable: false,
        groupable: false,
        width: '5%'
      },
      {
        text: 'Μονάδα',
        value: 'Unit',
        sortable: false,
        width: '8%'
      },
      {
        text: 'Τιμή',
        value: 'Price',
        sortable: false,
        groupable: false,
      },
      {
        text: 'Καθ. Αξία',
        value: 'gross',
        sortable: false,
        groupable: false,
      },
      {
        text: 'ΦΠΑ',
        value: 'vat',
        sortable: false,
        groupables: false,
      },
      {
        text: 'Αξία',
        value: 'value',
        sortable: false,
        groupable: false,
      },
      {
        text: 'Κατάσταση',
        value: 'Status',
        sortable: false,
        groupable: true,
      },
      {
        text: 'Τεχνικός',
        value: 'TechId',
        sortable: false,
        groupable: false,
      },
      { text: 'Επεξεργασία', value: 'actions', groupable:false, sortable: false , width: "150px"},
    ],
    histPartsHeader: [
      {
        text: 'Ημ/νία',
        value: 'Timestamp',
        sortable: false,
        width: '5%',
        groupable: false,
      },
      {
        text: 'Κωδικός',
        value: 'Sku',
        sortable: false,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Κωδικός',
        value: 'ManfSku',
        sortable: false,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Κατασκευαστής',
        value: 'Manf',
        sortable: false,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        sortable: false,
        groupable: false,
        width: '25%'
      },
      {
        text: 'Ποσότητα',
        value: 'Qty',
        sortable: false,
        groupable: false,
        width: '5%'
      },
      {
        text: 'Μονάδα',
        value: 'Unit',
        sortable: false,
        width: '8%'
      },
      {
        text: 'Τιμή',
        value: 'Price',
        sortable: true,
        groupable: false,
      },
      {
        text: 'Τεχνικός',
        value: 'Technician.Name',
        sortable: false
      },
      {
       text: 'Actions',
       value: 'actions',
       sortable: false,
       width: "150px",
       groupable: false
       },
    ],
    chargesHeader: [
      {
        text: 'Ημ/νία',
        value: 'Timestamp',
        sortable: false,
        width: '5%',
        groupable: false,
      },
      {
        text: 'Όχημα',
        value: 'PlateNumber',
        sortable: true,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Κωδικός',
        value: 'Sku',
        sortable: false,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Κατασκευαστής',
        value: 'Manf',
        sortable: false,
        width: '10%',
        groupable: true,
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        sortable: false,
        groupable: false,
        width: '25%'
      },
      {
        text: 'Ποσότητα',
        value: 'Qty',
        sortable: false,
        groupable: false,
        width: '5%'
      },
      {
        text: 'Μονάδα',
        value: 'Unit',
        sortable: false,
        width: '8%'
      },
      {
        text: 'Τιμή',
        value: 'Price',
        sortable: false,
        groupable: false,
      },
      {
        text: 'Τεχνικός',
        value: 'Tech',
        sortable: false
      },
      {
       text: 'Actions',
       value: 'actions',
       sortable: false,
       width: "150px",
       groupable: false
       },
    ],
    repairItems: [],
    statuses: [
      {value: -1, text: "Εκκρεμεί"},
      {value: 1, text: "Επισκευασμένο"},
      {value: 0, text: "Τιμολογημένο"},
      {value: -2, text: "Εξοφλημένο"},
     ],
    locationDialog: false,
    axleChecked: false,
    locationFields: {
      cabAxle: '',   // 'cab', '1', '2', '3', '4'
      side: 'L',     // 'L' or 'R'
      front: false,  // true if 'F'
      back: false,   // true if 'B'
    },
    editedIndex: -1,
    editedItem: {
      itemId: 0,
      Id: 0,
      Sku: '000-0000',
      Description: '',
      Qty: 1,
      Unit: 'TEM',
      Price: 0,
      Status: 1,
      Kind: 0,
      TechId: 1,
      Addon: null,
    },
    defaultItem: {
      Id: 0,
      itemId: 0,
      Sku: '000-0000',
      Description: '',
      Qty: 1,
      Unit: 'ΤΕΜ',
      Price: 0,
      Status: 1,
      Kind: 0,
      TechId: 1,
    },
    barcodeError: false,
    barcodeErrorMessage: '',
    barcodeDialog: false,
    barcodeInput: '',
    scannedItems: [],
    activeTab: 0, // 0 for Checkout, 1 for Collection
    headersCollection: [
      { text: 'Παρτίδα', value: 'CheckoutPart'},
      { text: 'Περιγραφή', value: 'Description' },
      { text: 'Ποσότητα', value: 'Qty' },
      { text: 'SKU', value: 'Sku' },
      { text: 'Αξία', value: 'Price' },
      { text: 'Θέση', value: 'Location' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    headersBarcode: [
      { text: 'Παρτίδα', value: 'Id' },
      { text: 'SKU', value: 'FmSku' },
      { text: 'Ημ/νια', value: 'Timestamp' },
      { text: 'Περιγραφή', value: 'Description', width: '20%' },
      { text: 'Ποσότητα', value: 'CoQty' },
      { text: 'Κωδ. Προμ.', value: 'SupplierSku' },
      { text: 'Απόθεμα', value: 'StockQty' },
      { text: 'Αξία', value: 'SuggestedPrice' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],

    }
  },
  async created () {
      this.initialize();
  },
 mounted() {

        this._keyListener = function(e) {
            if (e.key === "s" && (e.ctrlKey || e.metaKey)) {
                e.preventDefault(); // prevent "Save Page" from getting triggered.

                this.updateNotes();
            }
        };

        document.addEventListener('keydown', this._keyListener.bind(this));
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this._keyListener);
  },
  methods: {
   partServiceRatioUpdate(newValue) {
    console.log(newValue)
      if (newValue < 1) {
        this.partServiceEnabled = false;
        this.partDiscount = 0
      } else{
        this.partServiceEnabled = true;
        this.partDiscount = this.netParts * this.partServiceRatio/100

      }
    },
    roundToNearestTenOrFive(number) {
      console.log(number)
      const roundedNumber = Math.round(number / 5) * 5; // Round to the nearest multiple of 5
      if (roundedNumber % 10 === 5) {
        return roundedNumber; // Already rounded to the nearest multiple of 5
      } else if (roundedNumber % 10 > 5) {
        return Math.ceil(roundedNumber / 10) * 10; // Round up to the nearest multiple of 10
      } else {
        return Math.floor(roundedNumber / 10) * 10; // Round down to the nearest multiple of 10
      }
    },
   accountPage() {
        let path = "customer-info"
        let params = {"id": this.repair.Vehicle.Owner.Id}
        if (this.repair.Vehicle.Owner.Cid.startsWith("G")) {
              path = 'book-info';
        }

        this.$router.push({"name": path, "params": params});
    },
    vehicleDetails() {
        let path = "Vehicle"
        let params = {"vehicle": this.repair.VehId}
        this.$router.push({"name": path, "params": params});
    },
    getIcon(typeCode) {
      return typeCode === 102 ? 'mdi-package-variant-closed' : 'mdi-account-wrench';
    },
    getAadeIcon(typeCode) {
      return typeCode === '1.1' ? 'mdi-package-variant-closed' : 'mdi-account-wrench';
    },
    sumTotals(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.Price*b.Qty || 0), 0);
    },
    sumProfit(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.Profit*b.Qty || 0), 0);
    },

    sumCost(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.NetCost*b.Qty || 0), 0);
    },

    sumService(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.Price*b.Qty || 0), 0);
    },
    getStatus (status) {
      if (status == -2) return "Εξοφλημένο";
      if (status == -1) return "Εκκρεμεί";
      if (status == 1) return "Επισκευασμένο";
      if (status == 0) return "Τιμολογημένο";
    },
    duplicateQuote () {
      return
    },
    async updateNotes () {
        await this.$api.patch("/repairs/"+this.$route.params.repairId, {Notes: this.repair.Notes, Odometer: this.repair.Odometer});
        this.snackText = `Αποθηκεύτηκε`;
          this.snackbar = true;
    },
    async invoice () {
        const response = await this.$api.patch("/repairs/invoice/"+this.$route.params.repairId);
        if (response.status == 202) {
              this.repair = response.data;
              this.repairItems = [];
              let j = 1;
              for (var value of this.repair.Items) {
                value.itemId = j;
                this.repairItems.push(value);
                j +=1;
              }
        }
    },
    async showHistory (item) {
        this.loading = true
        this.dialogHist = true
        let cid = this.repair.Vehicle.Owner.Id
        let non_billing = 0
        if (this.repair.Vehicle.Owner.Cid.startsWith("G"))
        {
            non_billing = 1
        }
        const response = await this.$api.get("/inventory/parts/charge-hist",{ params: {part_sku: item.Sku, customer_id: cid, 'non-billing': non_billing} });
        if (response.status == 200) {

              this.charges = response.data;
              //console.log(this.charges);
              }
        this.loading = false
    },
    async send () {
        const response = await this.$api.get("/repairs/send/"+this.$route.params.repairId);
        if (response.status == 200) {
            this.snackText = `Εστάλη επιτυχώς`;
            this.snackbar = true;
        } else {
            this.snackText = `Προέκυψε σφάλμα κατα την αποστολή. ${response.data.details}`;
            this.snackbar = true;
        }
    },
    async getPDF () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/card`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
     async getPDFWOP () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/cardnop`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
     async getPDFBlack () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/cardblack`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
     async getPDFCODE39 () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/code39`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
     async getDCL () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/dcl`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
    openGarageDialog() {
      this.garageDialog = true;
      // this.fab = false;
    },
    onGarageUploaded(items) {
      console.log(items);
    },
    getServiceLabel() {
      this.repairId = this.repair.Id;
      this.labelShow = true;
    },
    handleDialogClose () {
      this.labelShow = false;
    },
    async getProforma () {
        const response = await this.$api.get(`/repairs/${this.repair.Id}/proforma`);
        window.open(`${this.$api.defaults.baseURL}/repairs/card/${response.data}`, '_blank');
    },
    async convertToQuote () {
        const response = await this.$api.get('/quotes/convert-from-repair', {params:{ repair_id: this.repair.Id }});
        this.$router.push('/quote/edit/'+response.data.sha);
    },
    rowClass (item) {
      if (item.Kind == 0) return 'white darken-2'
      if (item.Kind == 1) return 'blue-grey lighten-5'
      if (item.Kind == 2) return 'blue lighten-5'
      //item.Kind ? 'blue-grey lighten-5' : 'white darken-2';
      //return this.repairItems.indexOf(item) %2 ? 'blue-grey lighten-5' : 'white darken-2';
    },
    async initialize () {
      this.loading = true
      this.getRepair();
      const techs = await this.$api.get("/repairs/technicians/");
      this.technicians = techs.data;

      this.getParts();

      var respHistParts = await this.$api.get("/repairs/vehicles/"+this.repair.VehId+"/items");
      this.histParts = respHistParts.data;
      // console.log(this.quote);
      // await this.fetchDigitalClientDetails();
      this.loading = false

    },
    async getParts() {
      const partsResp = await this.$api.get("/inventory/stock");
      this.parts = partsResp.data;
      this.parts = this.parts.sort((a, b) => {
      if (a.Id < b.Id) {
        return 1;
      }
      if (a.Id > b.Id) {
        return -1;
      }
      return 0;
      })
      this.fetchPartsFilter(this.orderSearch);
    },
    copyItem (item) {
      const addObj = Object.assign({}, item);
      addObj.itemId = this.repairItems.length + 1;
      this.repairItems.unshift(addObj);
    },
    editItem (item) {
      this.editedIndex = this.repairItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    locateItem (item) {
      this.editedIndex = this.repairItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.openLocationDialog();
    },
    openLocationDialog() {
      // Parse editedItem.Location into fields
      const loc = (this.editedItem.Location || '').toUpperCase();
      let cabAxle = '';
      let side = 'L';
      let front = false;
      let back = false;

      // Regex: CAB-L-F, 1-R, 2-L-B, etc.
      const match = loc.match(/^(CAB|[1-4])(?:-([LRMA]))?(?:-([FB]))?$/);
      if (match) {
        cabAxle = match[1] || '';
        side = match[2] || 'L';
        front = match[3] === 'F';
        back = match[3] === 'B';
      }
      if (side === 'A') {
        this.axleChecked = true;
      } else {
        this.axleChecked = false;
      }
      this.locationFields = { cabAxle, side, front, back };
      this.locationDialog = true;
    },

    saveLocationDialog() {
      // Compose location string from fields
      let loc = this.locationFields.cabAxle;
      if (this.locationFields.side) loc += '-' + this.locationFields.side;
      if (this.locationFields.front) loc += '-F';
      else if (this.locationFields.back) loc += '-B';
      this.editedItem.Location = loc;
      this.save();

      this.locationDialog = false;
    },
    async deleteItem (item) {
      const index = this.repairItems.indexOf(item);
      if (confirm('Are you sure you want to delete this item?')) {
        if (item.Id) {
            const resp = await this.$api.delete("/repairs/items/"+item.Id);
          if (resp.status == 200) {
            this.repairItems.splice(index, 1);
          } else {
            alert(resp.data.detail);
          }
        } else {
              this.repairItems.splice(index, 1);
          }

      }
    },

    async getRepair() {

      const response = await this.$api.get("/repairs/" + this.$route.params.repairId, {cache: {maxAge: 30*1000}});
      this.repair = response.data;
      let j = 1;
      this.repairItems = []
      for (var value of this.repair.Items) {
        value.itemId = j;
        this.repairItems.push(value);
        j +=1;
      }

    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300)
    },
    addNew() {
       const addObj = Object.assign({}, this.defaultItem);
       addObj.itemId = this.repairItems.length + 1;
       this.repairItems.unshift(addObj);
       this.editItem(addObj);
    },
    addService() {
       const addObj = Object.assign({}, this.defaultItem);
       addObj.itemId = this.repairItems.length + 1;
       addObj.Kind = 1;
       addObj.Unit = '';
       addObj.Description = 'EΞΑΓΩΓΗ ΚΑΙ ΑΝΤΙΚΑΤΑΣΤΑΣΗ ΑΝΤΑΛΛΑΚΤΙΚΩΝ';
       addObj.Sku = '030';
       this.repairItems.unshift(addObj);
       this.editItem(addObj);
    },
    addItem(desc) {
      const newItem = {
        FmSku: "030",
        Price: 0,
        Qty:1,
        Description: desc,
      }
      this.$services.push(newItem)
      return newItem
    },
    onServiceChange(entry) {
      if (typeof entry === 'string' && entry.trim()) {
        const item = this.$services.find(item => item.Description === entry)
        if (item) {
          this.service = item
        } else {
          this.service = this.addItem(entry)
        }
      }
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    async savePart () {
        let checkout = {
            RepairId: this.repair.Id,
            OrderId: this.order.Id,
            TechId: this.partTechId,
            Qty: this.partQty,
            Status: this.isCollection,
        }
        await this.$api.post("/inventory/parts/checkout", checkout)
//      console.log(response);
        this.getRepair();
        this.getParts();
        this.fetchPartsFilter(null);

    },
    async saveService () {
        const addObj = Object.assign({}, this.defaultItem);
        addObj.itemId = this.repairItems.length + 1;
        addObj.Kind = 1;
        addObj.Unit = '';
        addObj.Description = this.service.Description.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
        addObj.Sku = this.service.FmSku;
        addObj.Qty = this.service.Qty;
        addObj.Price = this.service.Price;
        addObj.TechId = this.partTechId;
        this.repairItems.push(addObj);
        this.patchRepairItem(-1);
        // this.initialize();

    },

    parseJson() {
      try {
        const parsed = JSON.parse(this.jsonText);
        if (!Array.isArray(parsed)) {
          this.$toast && this.$toast.error && this.$toast.error("JSON must be an array of jobs.");
          return;
        }
        // Normalize each job to ensure required fields exist
        this.jobs = parsed.map(j => ({
          jobTitle: j.jobTitle || "",
          time: typeof j.time === "number" ? j.time : parseFloat(j.time) || 0,
          rate: typeof j.rate === "number" ? j.rate : parseFloat(j.rate) || 0,
          subJobs: Array.isArray(j.subJobs) ? j.subJobs.slice() : []
        }));
        // optional: close editor or leave open for edits
      } catch (e) {
        this.$alert ? this.$alert("Invalid JSON") : console.error("Invalid JSON", e);
      }
    },
    addSubJob(jobIdx) {
      this.jobs[jobIdx].subJobs.push("");
    },
    removeSubJob(jobIdx, subIdx) {
      this.jobs[jobIdx].subJobs.splice(subIdx, 1);
    },
    removeJob(idx) {
      this.jobs.splice(idx, 1);
    },
    reset() {
      this.jsonText = "";
      this.jobs = [];
    },
    computeSubtotal(job) {
      const t = Number(job.time) || 0;
      const r = Number(job.rate) || 0;
      return (t * r).toFixed(2);
    },
    async saveJobs() {
      // Validate minimal fields
      for (const j of this.jobs) {
        if (!j.jobTitle) {
          this.$toast && this.$toast.error && this.$toast.error("Each job needs a title.");
          return;
        }
      }

      // Placeholder uploader - replace with actual API call
      try {
        await this.uploadJobs(this.jobs);
        this.dialog4 = false;
        this.$emit("saved", this.jobs);
      } catch (err) {
        console.error("Upload failed", err);
        this.$toast && this.$toast.error && this.$toast.error("Upload failed");
      }
    },
    uploadJobs(jobs) {
      // Iterate jobs and perform the requested operations synchronously
      for (const job of jobs) {
        const addObj = Object.assign({}, this.defaultItem);
        addObj.itemId = this.repairItems.length + 1;
        addObj.Kind = 1;
        addObj.Unit = 'ΩΡΑ';
        // use job.jobTitle (fallback to job.title) and normalize accents -> uppercase
        const title = (job.jobTitle || job.title || "").toString();
        addObj.Description = title.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
        addObj.Sku = '999';
        addObj.Qty = job.time;
        addObj.Price = job.rate;
        addObj.TechId = job.partTechId;
        this.repairItems.push(addObj);
        // call patchRepairItem with -1
        try {
          this.patchRepairItem(-1);
        } catch (e) {
          console.warn("patchRepairItem failed (placeholder):", e);
        }
      }
      console.log("repairItems after placeholder upload:", this.repairItems);
    },
    clearOrder(val) {
      if (val) this.partsFiltered = [];
      this.order = {StockQty: 0};
      this.orderSearch = '';
    },
    handleFocus(isFocused) {
      if (isFocused && !this.orderSearch) {
        this.showLatestItems();
      }
    },
    showLatestItems() {
      // Fetch the latest 20 items from the parts list
      this.partsFiltered = this.allParts.slice(20);
    },
    updateSearchInput(search) {
      if (search == null) {
        this.prefixIcon = 'mdi-tag'; // No icon if there's no input
        return
      }

      const inputValue = search.toString();
      if (inputValue.startsWith('#')) {
        this.prefixIcon = 'mdi-tag-text'; // Example icon for SKU
      } else if (inputValue.startsWith('@')) {
        this.prefixIcon = 'mdi-clipboard-list-outline'; // Example icon for matches
      } else if (inputValue.startsWith('!')) {
        this.prefixIcon = 'mdi-counter'; // Example icon for wildcard
      } else {
        this.prefixIcon = 'mdi-clipboard-text'; // Default icon or no icon
      }
    },

    focusBarcodeInput() {
      this.$nextTick(() => {
          this.$refs.barcodeInputField.focus();
        });
    },
    deleteBarcodeItem(item) {
      this.scannedItems = this.scannedItems.filter(i => i.uniqueId !== item.uniqueId);
    },
    clearAllItems() {
      this.scannedItems = [];
    },
    validateCoQty (item) {
      if (item.StockQty > item.CoQty) {
        return true;
      }
      return false;
    },
    checkBarcode() {

      const barcodeInput = this.$refs.barcodeInputField;
      const barcode = barcodeInput ? barcodeInput.$el.querySelector('input').value.trim().toLowerCase() : '';
      // const barcode = this.barcodeInput.trim().toLowerCase();
      barcodeInput.$el.querySelector('input').value = ''; // Clear the input field after checking

      let part = null;
      if (this.activeTab === 0){
        if (barcode.startsWith('pb-') || barcode.startsWith('πβ-')) {
          const fmSku = barcode.substring(3);
          part = this.parts.find(p => p.FmSku === fmSku);
        } else if (barcode.startsWith('oic-') || barcode.startsWith('οιψ-')) {
          const id = parseInt(barcode.substring(4), 10);
          part = this.parts.find(p => p.Id === id);
        } else if (barcode.startsWith('pic-') || barcode.startsWith('πιψ-')) {
          const id = parseInt(barcode.substring(4), 10);
          const orders = this.parts.filter(p => p.PartId === id);
          // Sort orders by Id to find the oldest
          orders.sort((a, b) => a.Id - b.Id);

          for (let order of orders) {
            const existingItem = this.scannedItems.find(item => item.Id === order.Id);

            if (existingItem) {
              if (existingItem.CoQty + 1 <= order.StockQty) {
                part = order;
                break;
              }
            } else if (order.StockQty > 0) {
              part = order;
              break;
            }
          }

          if (!part) {
            this.barcodeError = true;
            this.barcodeErrorMessage = 'Η ποσότητα αποθήκης δεν είναι επαρκής!';
            return;
          }
        } else {
          const id = parseInt(barcode, 10);
          if (!isNaN(id)) {
            part = this.parts.find(p => p.Id === id);
          }
        }

        if (part) {
          this.handleBarcodeResult(part, 'Id');
        } else {
          this.barcodeError = true;
          this.barcodeErrorMessage = 'Λανθασμένος τύπος barcode ή δεν υπάρχει ανταλλακτικό με αυτόν τον κωδικό';
        }

      } else {
        if (barcode.startsWith('pb-') || barcode.startsWith('πβ-')) {
          const fmSku = barcode.substring(3);
          part = this.collectionItems.find(p => p.Sku === fmSku);
          part.Qty -= 1;
          if (part.Qty == 0) {
            part.Status = 1
          }
        } else if (barcode.startsWith('oic-') || barcode.startsWith('οιψ-')) {
          const id = parseInt(barcode.substring(4), 10);
          part = this.collectionItems.find(p => p.CheckoutPart === id);
          part.Qty -= 1;
          if (part.Qty == 0) {
            part.Status = 1
          }
        }
      }
    },

    handleBarcodeResult(part, key) {
      const existingItem = this.scannedItems.find(item => item[key] === part[key]);

      if (existingItem) {
        if (existingItem.StockQty >= existingItem.CoQty + 1) {
          existingItem.CoQty += 1;
        } else {
          this.barcodeError = true;
          this.barcodeErrorMessage = 'Μη επαρκής ποσότητα για αυτήν την παρτίδα!';
          return;
        }
      } else {
        const newPart = { ...part, uniqueId: this.generateUniqueId(), checkoutError: false, CoQty: 1 };
        this.scannedItems.push(newPart);
      }

      this.barcodeError = false; // Reset error state
      this.barcodeErrorMessage = ''; // Clear error message
    },
    generateUniqueId() {
      return '_' + Math.random().toString(36).substr(2, 9);
    },
    barcodeRowClasses(item) {
      if (item.checkoutError) return "checkout-error"
    },
    async copyCheckoutToCollection() {
      // Assuming scannedItems is an array available in the component's data
      for (let i = 0; i < this.scannedItems.length; i++) {
        const item = this.scannedItems[i];

        let checkout = {
          RepairId: this.repair.Id,
          OrderId: item.Id,
          TechId: this.partTechId,
          Qty: item.CoQty,
          Status: -1,
        };
        try {
          await this.$api.post("/inventory/parts/checkout", checkout);
          // Remove the item from the list if the post is successful
          this.scannedItems.splice(i, 1);
          i--; // Adjust the index after removal
        } catch (error) {
          console.error("Failed to post item:", error);
          item.checkoutError = true;
          // Handle the error as needed
        }
      }
      this.getRepair();
      this.getParts();
    },
    async saveBarcodeData() {
      if (this.activeTab === 0){
        // Assuming scannedItems is an array available in the component's data
        for (let i = 0; i < this.scannedItems.length; i++) {
          const item = this.scannedItems[i];
          console.log(item)

          // let addObj = Object.assign({}, this.defaultItem);
          // addObj.itemId = this.repairItems.length + 1;
          // addObj.Kind = 0;
          // addObj.Unit = item.Unit;
          // addObj.Description = item.Description;
          // addObj.Sku = item.FmSku;
          // addObj.Qty = item.CoQty;
          // addObj.Price = item.PartCost;
          // addObj.TechId = this.partTechId;
          // addObj.CheckoutPart = item.CheckoutPart;
          // this.repairItems.push(addObj);
          // this.patchRepairItem(-1);

          let checkout = {
            RepairId: this.repair.Id,
            OrderId: item.Id,
            TechId: this.partTechId,
            Qty: item.CoQty,
            Status: 1,
          };
          try {
            await this.$api.post("/inventory/parts/checkout", checkout);
            // Remove the item from the list if the post is successful
            this.scannedItems.splice(i, 1);
            i--; // Adjust the index after removal
          } catch (error) {
            console.error("Failed to post item:", error);
            item.checkoutError = true;
            // Handle the error as needed
          }
        }
        this.getRepair();
        this.getParts();
        if (!(this.scannedItems.length > 0)) {
          this.barcodeDialog = false;
        }
      } else { // Tab is collection so we don't have to do anything special
        this.barcodeDialog = false;
      }
    },
    prependPrefix(prefix) {
      // Define the possible prefixes
      const prefixes = ['#', '!', '@', '$'];

      // Check if orderSearch is defined and not empty
      if (this.orderSearch) {
        // Remove existing prefix if present
        const firstChar = this.orderSearch.charAt(0);
        if (prefixes.includes(firstChar)) {
          this.orderSearch = this.orderSearch.substring(1);
        }
      }

      // Prepend the new prefix
      this.orderSearch = prefix + (this.orderSearch || '');
      this.updateSearchInput(this.orderSearch);
    },
    fetchPartsFilter(queryText) {
      if (queryText == null || queryText == "") {
        // this.showLatestItems();
        this.partsFiltered = [];
        return false;
      }

      // Determine the search mode based on the prefix
      const isSkuSearch = queryText.startsWith('#');
      const isRefSearch = queryText.startsWith('@');
      const isIdSearch = queryText.startsWith('!');
      let searchText = '';
      if (isRefSearch || isSkuSearch || isIdSearch) {
        searchText = queryText.slice(1).toUpperCase(); // Remove prefix for actual search
      } else {
        searchText = queryText.toUpperCase(); // To uppercase for search
      }

      // Convert '*' to a regex pattern for fuzzy matching
      const searchPattern = new RegExp('^' + searchText.replace(/[^\p{L}\p{N}\\*]/gu, '').replace(/\*/g, '.*') + '.*$', 'i');
      const searchFmSkuPattern = new RegExp('^.*\\.' + searchText.replace(/\*/g, '.*') + '$', 'i');
      const searchSkuPattern = new RegExp('^.*' + searchText.replace(/\*/g, '.*') + '.*$', 'i');
      // Split the search text into individual terms
      const searchTerms = searchText.split(/\s+/);

      // Filter the parts array
      this.partsFiltered = this.parts.filter(item => {
        const desc = item.Description.toUpperCase();
        const remarks = item.Remarks || "";
        const supSku = item.SupplierSku.toUpperCase();
        const manfSku = item.ManufacturerSku.toUpperCase();
        const FmSku = item.FmSku.toUpperCase();
        const order = item.Id;
        const partId = item.PartId;

        // Fuzzy search for description
        const descMatches = searchTerms.every(term => desc.includes(term));
        const remarksMatches = searchTerms.some(term => remarks.includes(term));

        // Search in FmSku
        const skuMatches = searchFmSkuPattern.test(FmSku);

        // Apply search logic based on the prefix
        if (isSkuSearch) {
          return skuMatches || searchSkuPattern.test(supSku) || searchSkuPattern.test(manfSku);
        } else if (isRefSearch) {
          // Assuming `item.References` is available and similar to `fetchFilteredParts`
          const refs = item.References || [];
          return refs.some(o => searchPattern.test(o.Sku.replace(/[^\p{L}\p{N}]/gu, '')));
        } else if (isIdSearch) {
          return order == searchText || partId == searchText;
        } else {
          return descMatches || remarksMatches;
        }
      });
    },
    customFilter(item, queryText) {
      if (queryText == null) {
        this.partsFiltered = [];
        return false;
      }
      // Determine the search mode based on the prefix
      const isSkuSearch = queryText.startsWith('#');
      const isRefSearch = queryText.startsWith('@');
      const isIdSearch = queryText.startsWith('!');
      let searchText = '';
      if (isRefSearch || isSkuSearch || isIdSearch) {
        searchText = queryText.slice(1).toUpperCase(); // Remove prefix for actual search
      } else {
        searchText = queryText.toUpperCase(); // To uppercase for search
      }

      // Convert '*' to a regex pattern for fuzzy matching
      const searchPattern = new RegExp('^' + searchText.replace(/[^\p{L}\p{N}\\*]/gu, '').replace(/\*/g, '.*') + '.*$', 'i');
      const searchFmSkuPattern = new RegExp('^.*\\.' + searchText.replace(/\*/g, '.*') + '$', 'i');
      const searchSkuPattern = new RegExp('^.*' + searchText.replace(/\*/g, '.*') + '.*$', 'i');
      // Split the search text into individual terms
      const searchTerms = searchText.split(/\s+/);

      const desc = item.Description.toUpperCase();
      const supSku = item.SupplierSku.toUpperCase();
      const manfSku = item.ManufacturerSku.toUpperCase();
      const FmSku = item.FmSku.toUpperCase();
      const order = item.Id;
      const partId = item.PartId;

      // Fuzzy search for description
      const descMatches = searchTerms.every(term => desc.includes(term));

      // Search in FmSku
      const skuMatches = searchFmSkuPattern.test(FmSku);

      // Apply search logic based on the prefix
      if (isSkuSearch) {
        return skuMatches || searchSkuPattern.test(supSku) || searchSkuPattern.test(manfSku);
      } else if (isRefSearch) {
        // Assuming `item.References` is available and similar to `fetchFilteredParts`
        const refs = item.References || [];
        return refs.some(o => searchPattern.test(o.Sku.replace(/[^\p{L}\p{N}]/gu, '')));
      } else if (isIdSearch) {
        return order == searchText || partId == searchText;
      } else {
        return descMatches
      }
    },
    customServiceFilter (item, queryText) {
       const desc = item.Description
       const FmSku = item.FmSku
       const searchText = queryText.toUpperCase();
       return desc.includes(searchText) || FmSku.includes(searchText)
    },
    async createDigitalClientEntry() {
      this.creatingDigitalClient = true;
      try {
        let client = {
          RepairId: this.repair.Id
        }
        const response = await this.$api.post('/aade/dcl/new_client', client);
        console.log(response)
        this.repair.DigitalClientListId = response.data.dcl_id;
        await this.fetchDigitalClientDetails();
        this.creatingDigitalClient = false;
      } catch (e) {
        this.$notify({ type: 'error', message: 'Failed to create digital client entry.' });
      }
    },
    async fetchDigitalClientDetails() {
      if (!this.repair.DigitalClientListId) return;
      // Replace with your actual API call
      const details = await this.$api.get('/aade/dcl/info/'+this.repair.DigitalClientListId);
      this.digitalClientCompleted = details.data.Completed;
      this.digitalClientUpdates = details.data.Updates || [];
      this.digitalClientCorrelations = details.data.Correlations || [];

      // If digitalClientCorrelations is not empty, fetch correlated invoices
      if (this.digitalClientCorrelations && this.digitalClientCorrelations.length > 0) {
        await this.getCorrelatedInvoices();
      }

      // Only try to find related invoices for correlation if completed and there are no correlations
      if (
        this.digitalClientCompleted &&
        (!this.digitalClientCorrelations || this.digitalClientCorrelations.length === 0)
      ) {
        await this.findCorrelations();
      }
    },
    async findCorrelations() {
      const details = await this.$api.get('/invoices/find_correlations/' + this.repair.Id);
      // Get all correlated marks from digitalClientCorrelatedInvos
      const correlatedMarks = this.digitalClientCorrelatedInvos.map(inv => inv.Mark);
      // Filter out invoices whose AadeMark is already correlated
      this.digitalClientNewCorrelationInvos = details.data.filter(
        inv => !correlatedMarks.includes(inv.Mark)
      );
    },
    async getCorrelatedInvoices() {
      // Extract the mark attribute from each item in digitalClientCorrelations
      const marks = this.digitalClientCorrelations.map(item => item.Mark);
      const correlations = {Marks: marks}
      const resp = await this.$api.post('/aade/dcl/correlations-by-mark', correlations );
      this.digitalClientCorrelatedInvos = resp.data;
    },
    async updateDigitalClientEntry() {
      this.updatingDigitalClient = true;
      try {
        // Replace with your actual API call
        await this.$api.post('/aade/dcl/update_client', {
          InitialDclId: this.repair.DigitalClientListId,
          ProvidedServiceCategory: this.digitalClientForm.serviceType,
          EntryCompletion: this.digitalClientForm.completed,
          Comments: this.digitalClientForm.comments,
        });
        await this.fetchDigitalClientDetails();
        this.updatingDigitalClient = false;
      } catch (e) {
        this.$notify({ type: 'error', message: 'Failed to update digital client entry.' });
      }
    },
    async correlateInvoices() {
      this.correlatingDigitalClient = true;
      const invoiceMarks = this.selectedInvoices.map(invoice => invoice.Mark);
      try {
        await this.$api.post('/aade/dcl/correlate_invoices', {
          DclId: this.repair.DigitalClientListId,
          Invoices: invoiceMarks,
        });
        this.digitalClientNewCorrelationInvos = []; // Optionally clear selection after correlation
        this.selectedInvoices = []; // Optionally clear selection after correlation
        await this.fetchDigitalClientDetails();
        this.correlatingDigitalClient = false;
      } catch (e) {
        this.$notify({ type: 'error', message: 'Failed to update digital client entry.' });
      }
    },
    toggleInvoiceSelection(invoice) {
      const idx = this.selectedInvoices.findIndex(i => i.Id === invoice.Id);
      if (idx === -1) {
        this.selectedInvoices.push(invoice);
      } else {
        this.selectedInvoices.splice(idx, 1);
      }
    },
    isInvoiceCorrelated(invoice) {
      // Check if the invoice's AadeMark matches any item.Mark in the correlated list
      return this.digitalClientCorrelations.some(item => item.Mark === invoice.Mark);
    },
    isInvoiceSelected(invoice) {
      return this.selectedInvoices.some(i => i.Id === invoice.Id);
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.repairItems[this.editedIndex], this.editedItem);
        this.patchRepairItem(this.editedIndex);
      } else{
        this.repairItems.push(this.editedItem);
        this.patchRepairItem(-1);
      }
      this.close()
    },
    async patchRepairItem(itemIndex) {
      let item = this.repairItems.at(itemIndex);
      item.RepairId = this.$route.params.repairId
      if (item.Addon) {
        item.Kind = 2;
      } else {
        if (item.Kind == 2) {
          item.Kind = 0;
        }
      }
      if (item.Id) {
        const response = await this.$api.patch("/repairs/items/"+item.Id, item)
          //console.log(response);
          item.Sku = response.data.Sku;
          item.Description = response.data.Description;

      } else {
        const response = await this.$api.post("/repairs/items/", item)
          // console.log(response);
        item.Id = response.data.Id;
      }
      /* if (item.Addon) {
        this.getRepair()  // get repair items to update items with addons
      }
      */
    },
    addonsValue(item) {
      let v = this.repairItems.filter(e => e.Addon == item.Id)
      let value = v.reduce((total,current) => total + (current.Qty * current.Price), 0)
      return value
    }
  },
  }
</script>

<style>
.row-odd {
  background-color: orange;
}
.row-even {
  background-color: "red";
}
.checkout-error {
  background-color: orange;
}

.selected-invoice {
  background-color: #e3f2fd !important; /* Light blue, adjust as needed */
}

.correlated-invoice {
  background-color: #c8e6c9 !important; /* Light green for already correlated */
  pointer-events: none;
  opacity: 0.7;
}

/* .v-overlay--active {
    backdrop-filter: blur(4px);
    background: rgb(0 0 0 / 0.6);
} */

</style>
